import { render, staticRenderFns } from "./LobbyNavbar.vue?vue&type=template&id=6b2e732b&scoped=true&"
import script from "./LobbyNavbar.vue?vue&type=script&lang=js&"
export * from "./LobbyNavbar.vue?vue&type=script&lang=js&"
import style0 from "./LobbyNavbar.vue?vue&type=style&index=0&id=6b2e732b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2e732b",
  null
  
)

export default component.exports